import apiClient from 'utilities/api-client';
import type { HttpViewCustomerNoteGoalsResponse } from '@handlers/http/portal/customer/view/http-view-customer-note-goals';

export const fetchCustomerNoteGoals = async ({ customerId, noteId }: { customerId: string; noteId: string }) => {
  const response = await apiClient.get<HttpViewCustomerNoteGoalsResponse>(
    `/api/portal/customers/${customerId}/note-goals/${noteId}`,
  );
  return response.data;
};
